import PropTypes from 'prop-types';
import React from 'react';
import Icon from '@mui/material/Icon';
import Chip from '../Chip';

export const getColorForItem = (itemList, elementId) => {
  const item = itemList.filter((i) => i.id === elementId)[0];
  return item === undefined
    ? ''
    : item.iconColor;
};

export const TagComponent = ({
  tag,
  icon,
  color,
  actionIcon,
  onAction,
  showAction,
  clickable,
  onClick,
  disableGutters,
  size,
}) => (
  <Chip
    icon={icon
      ? (
        <Icon style={{ color }}>
          {icon}
        </Icon>
      )
      : null}
    component="div"
    label={tag.name}
    deleteIcon={actionIcon}
    onDelete={onAction}
    showDelete={showAction}
    clickable={clickable}
    onClick={onClick}
    disableGutters={disableGutters}
    size={size}
  />
);

TagComponent.propTypes = {
  tag: PropTypes.object,
  icon: PropTypes.string,
  color: PropTypes.string,
  onAction: PropTypes.func,
  actionIcon: PropTypes.object,
  showAction: PropTypes.bool,
  clickable: PropTypes.bool,
  onClick: PropTypes.func,
  disableGutters: PropTypes.bool,
  size: PropTypes.string,
};

TagComponent.defaultProps = {
  tag: {},
  icon: '',
  color: '',
  onAction: () => {},
  actionIcon: null,
  showAction: false,
  clickable: false,
  onClick: () => {},
  disableGutters: false,
  size: 'medium',
};

export default TagComponent;
